var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.question.canAddPanel
    ? _c(
        "button",
        {
          class: _vm.question.getAddButtonCss(),
          attrs: { type: "button", id: _vm.question.addButtonId },
          on: { click: _vm.addPanelClick },
        },
        [
          _c(
            "span",
            { class: _vm.question.cssClasses.buttonAddText },
            [
              _c("survey-string", {
                attrs: { locString: _vm.question.locPanelAddText },
              }),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }